import { useRestPost, UseRestPostMutationOptions } from 'scbk-services';
import { APIS } from 'scbk-shared-module/constants/apiPaths';
import {
  AutVrfAddActivateRequest,
  AutVrfAddActivateResponse,
} from '../../types/api/autVrfAddActivate';
import { AutVrfAddActivateIdVerificationResponse } from '../../types/api/autVrfAddActivateIdVerification';
import {
  AutVrfAddApplyARSRequest,
  AutVrfAddApplyARSResponse,
} from '../../types/api/autVrfAddApplyARS';
import {
  AutVrfAddApplySimpleRequest,
  AutVrfAddApplySimpleResponse,
} from '../../types/api/autVrfAddApplySimple';
import {
  AutVrfAddApplySMSIdentifyRequest,
  AutVrfAddApplySMSIdentifyResponse,
} from '../../types/api/autVrfAddApplySMSIdentify';
import {
  AutVrfAddConfirmOverseasDepartureRequest,
  AutVrfAddConfirmOverseasDepartureResponse,
} from '../../types/api/autVrfAddConfirmOverseasDeparture';
import { AutVrfAddCreateARSAuthNumberResponse } from '../../types/api/autVrfAddCreateARSAuthNumber';
import { AutVrfAddGetDeviceAuthResponse } from '../../types/api/autVrfAddGetDeviceAuth';
import {
  AutVrfAddRegistDeviceAuthRequest,
  AutVrfAddRegistDeviceAuthResponse,
} from '../../types/api/autVrfAddRegistDeviceAuth';
import {
  AutVrfAddValidateSimpleRequest,
  AutVrfAddValidateSimpleResponse,
} from '../../types/api/autVrfAddValidateSimple';

/**
 * 추가인증 초기화
 * @param mutationOptions
 * @returns
 */
export function useAutVrfAddActivate(
  mutationOptions?: UseRestPostMutationOptions<AutVrfAddActivateRequest, AutVrfAddActivateResponse>,
) {
  return useRestPost<AutVrfAddActivateRequest, AutVrfAddActivateResponse>(
    {
      endpoint: APIS.auth.verification.additional.activate,
    },
    mutationOptions,
  );
}

/**
 * ARS 인증번호 요청
 * @param mutationOptions
 * @returns
 */
export function useAutVrfAddCreateARSAuthNumber(
  mutationOptions?: UseRestPostMutationOptions<void, AutVrfAddCreateARSAuthNumberResponse>,
) {
  return useRestPost<void, AutVrfAddCreateARSAuthNumberResponse>(
    {
      endpoint: APIS.auth.verification.additional.createARSAuthNumber,
    },
    mutationOptions,
  );
}

/**
 * ARS 전화요청
 */
export function useAutVrfAddApplyARS(
  mutationOptions?: UseRestPostMutationOptions<AutVrfAddApplyARSRequest, AutVrfAddApplyARSResponse>,
) {
  return useRestPost<AutVrfAddApplyARSRequest, AutVrfAddApplyARSResponse>(
    {
      endpoint: APIS.auth.verification.additional.applyARS,
    },
    mutationOptions,
  );
}

/**
 * 해외출국사실여부 조회
 * @param mutationOptions
 * @returns
 */
export function useAutVrfAddConfirmOverseasDeparture(
  mutationOptions?: UseRestPostMutationOptions<
    AutVrfAddConfirmOverseasDepartureRequest,
    AutVrfAddConfirmOverseasDepartureResponse
  >,
) {
  return useRestPost<
    AutVrfAddConfirmOverseasDepartureRequest,
    AutVrfAddConfirmOverseasDepartureResponse
  >(
    {
      endpoint: APIS.auth.verification.additional.confirmOverseasDeparture,
    },
    mutationOptions,
  );
}

/**
 * SMS 명의인증 요청
 * @param mutationOptions
 * @returns
 */
export function useAutVrfAddApplySMSIdentify(
  mutationOptions?: UseRestPostMutationOptions<
    AutVrfAddApplySMSIdentifyRequest,
    AutVrfAddApplySMSIdentifyResponse
  >,
) {
  return useRestPost<AutVrfAddApplySMSIdentifyRequest, AutVrfAddApplySMSIdentifyResponse>(
    {
      endpoint: APIS.auth.verification.additional.applySMSIdentify,
    },
    mutationOptions,
  );
}

export function useAutVrfAddApplySimple(
  mutationOptions?: UseRestPostMutationOptions<
    AutVrfAddApplySimpleRequest,
    AutVrfAddApplySimpleResponse
  >,
) {
  return useRestPost<AutVrfAddApplySimpleRequest, AutVrfAddApplySimpleResponse>(
    {
      endpoint: APIS.auth.verification.additional.applySimple,
    },
    mutationOptions,
  );
}

export function useAutVrfAddValidateSimple(
  mutationOptions?: UseRestPostMutationOptions<
    AutVrfAddValidateSimpleRequest,
    AutVrfAddValidateSimpleResponse
  >,
) {
  return useRestPost<AutVrfAddValidateSimpleRequest, AutVrfAddValidateSimpleResponse>(
    {
      endpoint: APIS.auth.verification.additional.validateSimple,
    },
    mutationOptions,
  );
}

export function useAutVrfAddGetDeivceAuth(
  mutationOptions?: UseRestPostMutationOptions<void, AutVrfAddGetDeviceAuthResponse>,
) {
  return useRestPost<void, AutVrfAddGetDeviceAuthResponse>(
    {
      endpoint: APIS.auth.verification.additional.getDeviceAuth,
    },
    mutationOptions,
  );
}

export function useAutVrfAddRegistDeviceAuth(
  mutationOptions?: UseRestPostMutationOptions<
    AutVrfAddRegistDeviceAuthRequest,
    AutVrfAddRegistDeviceAuthResponse
  >,
) {
  return useRestPost<AutVrfAddRegistDeviceAuthRequest, AutVrfAddRegistDeviceAuthResponse>(
    {
      endpoint: APIS.auth.verification.additional.registDeviceAuth,
    },
    mutationOptions,
  );
}

export function useAutVrfAddActivateIdVerification(
  mutationOptions?: UseRestPostMutationOptions<void, AutVrfAddActivateIdVerificationResponse>,
) {
  return useRestPost<void, AutVrfAddActivateIdVerificationResponse>(
    {
      endpoint: APIS.auth.verification.additional.activateIdVerification,
    },
    mutationOptions,
  );
}
